import {
  APP,
  CONFIG,
  PROFILES,
  ROLES,
  UNIT,
  IFRAME,
  MODULES
} from '../../utils/constants';
import { getAdminPreview } from '../../services/auth';
import bus from '../../utils/bus';
import i18n from '@/lang';

const {
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
  FINANCIAL_PROFILE,
  ADMIN_FINANCIAL_PROFILE
} = PROFILES;

const { CLIENT_ROLE, SYNDIC_ROLE } = ROLES;

const supportViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const documentViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const newsViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const bannerViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const bulletinViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const clientViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const clientUpdateProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const enterpriseViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE
];
const financialViewProfiles = [
  ADMIN_PROFILE,
  ADMIN_BEXS_PROFILE,
  ADMIN_HR_PROFILE,
  HR_PROFILE,
  FINANCIAL_PROFILE,
  ADMIN_FINANCIAL_PROFILE
];
const menuModules = {
  ENTERPRISE: 'enterprise',
  SYNDIC: 'syndic',
  FINANCIAL: 'financial',
  DOCUMENT: 'document',
  BULLETIN: 'bulletin',
  NEWS: 'news',
  SUPPORT: 'support',
  PROFILE: 'profile'
};

const moduleColors = {
  [menuModules.ENTERPRISE]: '#dc2c34',
  [menuModules.SYNDIC]: '#e0db37',
  [menuModules.FINANCIAL]: '#4bb629',
  [menuModules.DOCUMENT]: '#dc2c34',
  [menuModules.BULLETIN]: '#dc2c34',
  [menuModules.NEWS]: '#dc2c34',
  [menuModules.SUPPORT]: '#dc2c34',
  [menuModules.PROFILE]: '#dc2c34'
};

export default {
  state: {
    loadingApp: false,
    loadingConfig: false,
    adminPreview: JSON.parse(getAdminPreview()),
    showBlockadeWarning: false
  },
  getters: {
    [APP.ISLOADING]: state => state.loadingApp,
    [APP.IS_CONFIG_LOADING]: state => state.loadingConfig,
    [APP.IS_ADMIN_PREVIEW]: state => !!state.adminPreview,
    [APP.GET_ADMIN_PREVIEW]: state => state.adminPreview,
    [APP.NAVBAR_ROUTES]: (state, getters) => {
      const clientViewRoles = [CLIENT_ROLE];
      const syndicViewRoles = [SYNDIC_ROLE];

      return [
        {
          title: 'Empreendimento',
          icon: 'building',
          color: '#dc2c34',
          meta: {
            module: menuModules.ENTERPRISE,
            unitsSelect: true,
            profiles: enterpriseViewProfiles
          },
          dropdown: [
            {
              title: 'Meu empreendimento',
              path: '/empreendimento/meu-empreendimento',
              meta: {
                profiles: enterpriseViewProfiles
              }
            },
            {
              title: 'Decorado',
              path: '/empreendimento/decorado',
              meta: {
                profiles: enterpriseViewProfiles,
                conditions: ['showDecorated']
              }
            },
            {
              title: 'Acompanhe as Obras',
              path: '/empreendimento/acompanhe-as-obras',
              meta: {
                profiles: enterpriseViewProfiles,
                conditions: ['showInConstruction']
              }
            },
            {
              title: 'Parcerias e descontos',
              path: '/empreendimento/parceriasedescontos',
              meta: {
                profiles: enterpriseViewProfiles,
                conditions: ['showDiscounts']
              }
            }
          ]
        },
        {
          title: 'Manutenção',
          icon: 'wrench',
          color: moduleColors[menuModules.SYNDIC],
          vuexLink: UNIT.SYNDIC_MAINTENANCE_LINK,
          openForm: true,
          meta: {
            module: menuModules.SYNDIC,
            roles: syndicViewRoles
          }
        },
        {
          title: 'Financeiro',
          icon: 'finantial',
          color: moduleColors[menuModules.FINANCIAL],
          meta: {
            module: menuModules.FINANCIAL,
            profiles: financialViewProfiles,
            roles: clientViewRoles,
            conditions: ['notIndirectContract']
          },
          dropdown: [
            {
              title: 'Boleto(s) próximo vencimento',
              path: '/financeiro/boletos/proximo-vencimento',
              meta: {
                profiles: financialViewProfiles
              }
            },
            {
              title: 'Boleto(s) em atraso',
              path: '/financeiro/boletos/atraso',
              meta: {
                profiles: financialViewProfiles
              }
            },
            {
              title: 'Boleto(s) para antecipação',
              path: '/financeiro/boletos/antecipacao',
              meta: {
                profiles: financialViewProfiles
              }
            },
            {
              title: 'Posição financeira',
              path: '/financeiro/posicao-financeira',
              meta: {
                profiles: financialViewProfiles
              }
            },
            {
              title: 'Informe de rendimentos',
              path: '/financeiro/informe-de-rendimentos',
              meta: {
                profiles: financialViewProfiles
              }
            },
            {
              title: 'Financiamento Bancário',
              path: '/financeiro/financiamento-bancario',
              meta: {
                profiles: financialViewProfiles,
                conditions: ['showBankFinancing']
              }
            }
          ]
        },
        {
          title: 'Documentos',
          icon: 'docs',
          path: '/documentos/geral',
          color: '#ff7e00',
          meta: {
            module: menuModules.DOCUMENT,
            profiles: documentViewProfiles,
            dropDownConditions: ['hasDocs']
          },
          dropdown: [
            {
              title: 'Do empreendimento',
              subdivision: [
                {
                  title: 'Documentos gerais',
                  path: '/documentos/geral',
                  meta: {
                    profiles: documentViewProfiles,
                    conditions: ['hasGeneralDocs']
                  }
                },
                {
                  title: 'Documentos legais',
                  path: '/documentos/legal',
                  meta: {
                    profiles: documentViewProfiles,
                    conditions: ['hasLegalDocs']
                  }
                }
              ]
            },
            {
              title: 'Da unidade',
              path: '/documentos/proprietario',
              meta: {
                profiles: documentViewProfiles,
                conditions: ['hasOwnerDocs']
              }
            },
            {
              title: 'Do síndico',
              path: '/documentos/sindico',
              meta: {
                profiles: documentViewProfiles,
                conditions: ['hasSyndicDocs']
              }
            }
          ]
        },
        {
          path: '/comunicados',
          title: 'Comunicados',
          icon: 'notification',
          color: '#f958ff',
          meta: {
            module: menuModules.BULLETIN,
            profiles: bulletinViewProfiles
          }
        },
        {
          title: 'Notícias',
          icon: 'news',
          color: '#0093f0',
          meta: {
            module: menuModules.NEWS,
            profiles: newsViewProfiles
          },
          mustHaveChildren: true,
          dropdown: [
            // {
            //   title: 'Sala de imprensa',
            //   path: '/noticias/sala-de-imprensa',
            //   meta: {
            //     profiles: newsViewProfiles
            //   }
            // },
            // {
            //   title: 'Engenharia',
            //   path: '/noticias/engenharia',
            //   meta: {
            //     profiles: newsViewProfiles
            //   }
            // },
            // {
            //   title: 'Prêmios',
            //   path: '/noticias/premios',
            //   meta: {
            //     profiles: newsViewProfiles
            //   }
            // },
            {
              title: 'Aconteceu',
              path: '/noticias/aconteceu',
              meta: {
                profiles: newsViewProfiles,
                conditions: ['hasNewsVideos']
              }
            },
            ...getters[IFRAME.GET_NEWS_TYPES]
              .filter(news => news.enabled !== false)
              .map(news => ({
                title: i18n.t(`pages.news.${news.type}.title`),
                path: `/noticias/${i18n.t(`pages.news.${news.type}.path`)}`,
                meta: {
                  profiles: newsViewProfiles,
                  iframeData: news
                }
              }))
          ]
        },
        {
          title: 'Atendimento',
          icon: 'chat',
          color: '#0093f0',
          meta: {
            module: menuModules.SUPPORT,
            profiles: supportViewProfiles
          },
          dropdown: [
            {
              title: 'Abrir nova solicitação',
              path: '/atendimento/solicitacao/nova',
              meta: {
                profiles: supportViewProfiles,
                module: MODULES.TICKET_CRM
              }
            },
            {
              title: 'Acompanhar Solicitações',
              path: '/atendimento/solicitacao/consulta',
              meta: {
                profiles: supportViewProfiles,
                module: MODULES.TICKET_CRM
              }
            },
            {
              title: 'Perguntas Frequentes',
              path: '/atendimento/perguntas-frequentes',
              meta: {
                profiles: supportViewProfiles
              }
            },
            {
              title: 'Meus Compromissos',
              path: '/atendimento/meus-compromissos',
              meta: {
                profiles: supportViewProfiles
              }
            },
            {
              title: 'Agende sua vistoria',
              path: '/atendimento/solicitacao/vistoria',
              meta: {
                profiles: supportViewProfiles,
                conditions: ['hasInspection']
              }
            },
            {
              title: 'Ouvidoria',
              path: '/atendimento/solicitacao/ouvidoria',
              meta: {
                profiles: supportViewProfiles,
                module: MODULES.TICKET_CRM
              }
            },
            {
              title: 'Agende sua chave',
              path: '/atendimento/agendamento/entrega-de-chaves',
              meta: {
                profiles: supportViewProfiles,
                conditions: ['showKeyDeliveryOption']
              }
            }
          ]
        },
        {
          title: 'Meu cadastro',
          path: '/cadastro',
          icon: 'profile',
          color: '#5442c2',
          dropdown: [
            {
              title: 'Ver cadastro',
              path: '/cadastro',
              meta: {
                profiles: clientViewProfiles
              }
            },
            {
              title: 'Alterar senha',
              path: '/cadastro/senha',
              meta: {
                profiles: clientUpdateProfiles
              }
            }
          ],
          meta: {
            module: menuModules.PROFILE,
            profiles: clientViewProfiles
          }
        }
      ];
    },
    [APP.APP_MODULES]: (_state, getters) => {
      return {
        profile: {
          title: 'Meu Cadastro',
          description: 'Mantenha seu cadastro sempre atualizado',
          icon: 'profile',
          themeColor: '#5442c2'
        },
        legalDocs: {
          icon: 'legal-docs',
          title: 'Documentos Legais',
          description: 'Acompanhe os status dos documentos legais',
          themeColor: '#ff7e00'
        },
        ownerDocs: {
          icon: 'owner-docs',
          title: 'Documentos Proprietario',
          description: 'Acompanhe os status dos documentos do proprietário',
          themeColor: '#ff7e00'
        },
        docs: {
          icon: 'docs',
          title: 'Ultimos Documentos',
          description: 'Fique atento as últimas atualizações',
          themeColor: '#ff7e00'
        },
        support: {
          icon: 'chat',
          title: 'Atendimento',
          description: 'Acompanhe suas solicitações',
          themeColor: '#0093f0'
        },
        faq: {
          icon: 'faq',
          title: 'Perguntas frequentes',
          description: 'Tire suas dúvidas',
          themeColor: '#0093f0'
        },
        financialPosition: {
          icon: 'finantial-status',
          title: i18n.t('pages.financialPosition.moduleCard.title'),
          description: i18n.t('pages.financialPosition.moduleCard.description'),
          themeColor: moduleColors[menuModules.FINANCIAL]
        },
        paymentSlip: {
          icon: 'payment',
          title: i18n.t('pages.paymentSlip.moduleCard.title'),
          description: i18n.t('pages.paymentSlip.moduleCard.description', {
            toExpireDays: getters[CONFIG.GET_TO_EXPIRE_PERIOD_DAYS]
          }),
          themeColor: moduleColors[menuModules.FINANCIAL]
        },
        myDecorated: {
          icon: 'blueprint',
          title: 'Decorado',
          description: 'Detalhes do apartamento decorado',
          themeColor: '#dc2c34'
        },
        constructionProgress: {
          icon: 'construction',
          title: 'Andamento da Obra',
          description: '',
          themeColor: '#dc2c34'
        },
        myEnterprise: {
          icon: 'buildings',
          title: 'Meu empreendimento',
          description: 'Informações do meu empreendimento',
          themeColor: '#dc2c34'
        },
        appointment: {
          icon: 'calendar',
          title: 'Meus compromissos',
          description: 'Sua agenda de compromissos',
          themeColor: '#0093f0'
        },
        bankLoan: {
          icon: 'blueprint',
          title: 'Financiamento Bancário',
          description: 'Status do seu financiamento bancário',
          themeColor: moduleColors[menuModules.FINANCIAL]
        },
        productDocs: {
          icon: 'docs',
          title: 'Manual do proprietário',
          description: 'Acesse os documentos de sua unidade',
          themeColor: '#ff7e00'
        }
      };
    },
    [APP.PAGES]: (_state, getters) => {
      return {
        paymentSlip: {
          title: 'Boletos',
          icon: 'finantial-status',
          themeColor: moduleColors[menuModules.FINANCIAL],
          emptyState: {
            late: 'Não há boletos em atraso para este contrato',
            toExpire: 'Não há boletos a vencer para este contrato',
            anticipation: 'Não há boletos para antecipar'
          },
          texts: {
            toExpire: {
              description: {
                firstLine: i18n.t('pages.paymentSlip.toExpire.description', {
                  toExpireDays: getters[CONFIG.GET_TO_EXPIRE_PERIOD_DAYS]
                }),
                secondLine:
                  'Caso não consiga visualizá-lo(s), entre em contato com a Central de Relacionamento.',
                link: 'Abrir nova solicitação.'
              }
            },
            inDelayDescription: i18n.t('pages.paymentSlip.inDelayDescription', {
              slipTimeoutHours: getters[CONFIG.GET_SLIP_TIMEOUT_HOURS],
              slipSolicitationDays: getters[CONFIG.GET_SLIP_SOLICITATION_DAYS]
            }),
            discountCampaignDescription:
              '**Desconto válido para antecipação total da parcela'
          },
          tabs: [
            {
              title: 'Boleto(s) próximo vencimento',
              titleMobile: 'Próximo vencimento',
              value: '/financeiro/boletos/proximo-vencimento'
            },
            {
              title: 'Boleto(s) em atraso',
              titleMobile: 'Em atraso',
              value: '/financeiro/boletos/atraso',
              icon: 'bexsicon-alert'
            },
            {
              title: 'Boleto(s) para antecipação',
              titleMobile: 'Antecipação',
              value: '/financeiro/boletos/antecipacao'
            }
          ]
        },
        profile: {
          title: 'Meu Cadastro',
          icon: 'profile',
          themeColor: '#5442c2'
        },
        enterpriseDocs: {
          icon: 'docs',
          themeColor: '#ff7e00',
          title: 'Documentos do Empreendimento',
          emptyState: 'Não há documentos disponíveis para essa unidade.',
          tabs: [
            {
              title: 'Documentos Gerais',
              value: 'geral'
            },
            {
              title: 'Documentos Legais',
              value: 'legal'
            }
          ]
        },
        productDocs: {
          icon: 'docs',
          themeColor: '#ff7e00',
          title: 'Documentos da Unidade',
          emptyState: 'Não há documentos disponíveis para essa unidade.',
          tabs: [
            {
              title: 'Manual do Proprietário',
              value: 'proprietario'
            }
          ]
        },
        syndicDocs: {
          icon: 'docs',
          themeColor: '#ff7e00',
          title: 'Documentos do síndico',
          emptyState: 'Não há documentos disponíveis.',
          tabs: [
            {
              title: 'Manual do Síndico',
              value: 'sindico'
            }
          ]
        },
        support: {
          icon: 'chat',
          title: 'Atendimento',
          themeColor: '#0093f0',
          emptyState: 'Não há solitações para a unidade selecionada.',
          tabs: [
            {
              title: 'Abrir nova solicitação',
              value: '/atendimento/solicitacao/nova'
            },
            {
              title: {
                notMobile: 'Acompanhe suas solicitações',
                mobile: 'Suas solicitações'
              },
              value: '/atendimento/solicitacao/consulta'
            },
            {
              title: {
                notMobile: 'Ouvidoria',
                mobile: 'Ouvidoria'
              },
              value: '/atendimento/solicitacao/ouvidoria'
            }
          ]
        },
        keyDeliverySchedule: {
          icon: 'chat',
          title: 'Agendamento de entrega de chaves',
          themeColor: '#0093f0'
        },
        inspectionDetails: {
          icon: 'chat',
          title: 'Agendar vistoria em sua unidade',
          themeColor: '#0093f0',
          emptyState: 'Não há solitações para a unidade selecionada.',
          tabs: [
            {
              title: {
                notMobile: 'Agendamento',
                mobile: 'Agendamento'
              },
              value: '/atendimento/solicitacao/vistoria'
            }
          ]
        },
        faq: {
          icon: 'faq',
          title: 'Perguntas frequentes',
          description: 'Tire suas dúvidas',
          themeColor: '#0093f0'
        },
        bulletins: {
          title: 'Comunicados',
          icon: 'notification',
          themeColor: '#f958ff',
          emptyState: 'Não há comunicados para a unidade selecionada.'
        },
        financialPosition: {
          title: 'Posição Financeira',
          icon: 'finantial-status',
          themeColor: moduleColors[menuModules.FINANCIAL],
          emptyState: {
            late: 'Não há valores em atraso para a unidade selecionada.',
            toExpire: 'Não há valores a vencer para a unidade selecionada.',
            paid: 'Não há valores pagos para a unidade selecionada.'
          },
          texts: {
            baseDateDescription:
              'Atenção: Os valores constantes na posição financeira estão projetados para o último dia do mês vigente.'
          }
        },
        financialIR: {
          title: 'Informe de rendimento - IR',
          icon: 'finantial-status',
          themeColor: moduleColors[menuModules.FINANCIAL],
          emptyState: {
            income:
              'Não há informes de rendimentos para o contrato selecionado.'
          },
          texts: {
            description:
              'O demonstrativo abaixo apresenta todos os pagamentos efetuados a título de liquidação do saldo devedor da sua unidade. Ao declarar seu imposto de renda, tenha especial atenção as parcelas pagas através de financiamento bancário, uma vez que esses pagamentos são discriminados no informe anual emitido pelo seu banco e não devem ser lançados em duplicidade em sua declaração. Em caso de dúvidas consulte seu contador.'
          }
        },
        bankFinancing: {
          title: 'Financiamento Bancário',
          icon: 'finantial-status',
          description: '',
          themeColor: moduleColors[menuModules.FINANCIAL]
        },
        myEnterprise: {
          title: 'Meu empreendimento',
          icon: 'building',
          themeColor: '#dc2c34'
        },
        myDecorated: {
          title: 'Meu decorado',
          icon: 'blueprint',
          themeColor: '#dc2c34'
        },
        constructionProgress: {
          title: 'Andamento da obra',
          icon: 'construction',
          themeColor: '#dc2c34',
          texts: {
            description:
              'As fotos e cronograma das obras são atualizados mensalmente até o dia 30 de cada mês, podendo sofrer variações de acordo com as condições meteorológicas'
          }
        },
        discountList: {
          title: 'Parcerias e descontos',
          icon: 'financing',
          themeColor: '#dc2c34'
        },
        newsPressRoom: {
          title: 'Sala de Imprensa',
          icon: 'news',
          description: '',
          themeColor: '#0093f0'
        },
        newsEngineering: {
          title: 'Engenharia',
          icon: 'news',
          description: '',
          themeColor: '#0093f0'
        },
        newsAwards: {
          title: 'Prêmios',
          icon: 'news',
          description: '',
          themeColor: '#0093f0'
        },
        newsHappen: {
          title: 'Aconteceu',
          icon: 'news',
          description: '',
          themeColor: '#0093f0'
        },
        appointment: {
          icon: 'calendar',
          title: 'Meus compromissos',
          description: 'Sua agenda de compromissos',
          themeColor: '#0093f0'
        },
        credits: {
          icon: '',
          title: 'Créditos',
          description: '',
          themeColor: '#0093f0',
          showUnits: false
        },
        blockadeWarning: {
          icon: '',
          title: '',
          description: '',
          themeColor: '#0093f0',
          showUnits: false,
          showBreadcrumbs: false
        }
      };
    },
    [APP.BLOCKADE_WARNING]: (_state, getters) => {
      return getters[CONFIG.SHOW_BLOCKADE_WARNING]
        ? getters[CONFIG.GET_NAVIGATION_RULES].blockadeWarning.content
        : null;
    }
  },
  mutations: {
    [APP.LOADING]: state => {
      state.loadingApp = true;
    },
    [APP.LOADED]: state => {
      state.loadingApp = false;
    },
    [APP.LOADING_CONFIG]: state => {
      state.loadingConfig = true;
    },
    [APP.LOADED_CONFIG]: state => {
      state.loadingConfig = false;
    },
    [APP.MUTATE_ADMIN_PREVIEW]: (state, payload) => {
      state.adminPreview = payload;
    },
    [APP.OPEN_SNACKBAR]: (state, payload) => {
      bus.$emit(APP.OPEN_SNACKBAR, payload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js